import { modelComposition } from 'trait/composition'

const descriptor = 'model::request::item'

export default modelComposition(descriptor)
